import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "flag-icons/css/flag-icons.min.css";
import App from "@/App";

const isResizeObserverLoopError = (message) => (
  typeof message === 'string' && (
    message.includes('ResizeObserver loop completed with undelivered notifications')
    || message.includes('ResizeObserver loop limit exceeded')
  )
);

window.addEventListener('error', (event) => {
  if (isResizeObserverLoopError(event.message)) {
    event.stopImmediatePropagation();
  }
});

window.addEventListener('unhandledrejection', (event) => {
  const message = event?.reason?.message || String(event?.reason || '');
  if (isResizeObserverLoopError(message)) {
    event.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register the service worker on load so the app is installable (PWA)
// even before the user enables push notifications.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}
